import requestApi from "lib/services/api/common/boxp_api_client";
import requestrApi from "../../../common/boxr_api_client";


//Removed parts
function getRemovedParts(params) {
    return requestrApi({
        url: `/part_conditions/removed_parts`,
        method: "GET",
        params,
    });
}
//dispatch files


const getDispatchFiles = (params) => {
    return requestApi({

        url: `/get_dispatch_files`,
        method: "GET",
        params,
    })

}
const getTaskReport = (params) => {
    return requestrApi({
        url: `/operational_tasks/tasks_table`,
        method: "GET",
        params,
    });

}
const getTaskLibraryListing = (params) => {
    return requestrApi({
        url: `/task_libraries`,
        method: "GET",
        params,
    });

}

const updateApprovalState = (formData) => {
    return requestrApi({
        url: `/task_libraries/update_task_library`,
        method: "PUT",
        data: formData,
    });

}

export const RemovedParts = {
    getRemovedParts,
    getDispatchFiles,
    getTaskReport,
    getTaskLibraryListing,
    updateApprovalState
}